import React from "react";
import './student-performance-report.scss';
import CommonApi from "../../../../apis/common";
import DiagnosticAssessmentReport from "../../../student-performance-report/diagnostic-assessment-report-v1/diagnostic-assessment-report";
import Loading from "../../../common/loading/loading";
import SessionCache from "../../../routes/session-cache";
import { Constants } from "../../../../constants/constants";

class StudentPerformanceReport extends React.Component {


    state = {
        showDiagnosticAssessmentReport: false,
        categories: [
            {
                type: "NOVICE",
                title: "Novice",
                maxPercentage: 50,
                students: [],
                colorClass: "purble-header",
                selectedCriterion: 1
            },
            {
                type: "PROFICIENT",
                title: "Proficient",
                minPercentage: 50,
                maxPercentage: 80,
                students: [],
                colorClass: "orange-header",
                selectedCriterion: 1
            },
            {
                type: "ADVANCED",
                title: "Advanced",
                minPercentage: 80,
                students: [],
                colorClass: "litebule-header",
                selectedCriterion: 1
            }
        ],
        isLoading: true
    }

    constructor(props) {
        super(props)
        console.log(this.props.selectedItem, this.props.type)
        this.userInfo = SessionCache.getUser()
        this.getPerformanceReport()
        
    }

    componentDidMount() {

    }


    getPerformanceReport() {
        let payload = {
            // board: this.state.selectedBoard,
            // class: this.state.selectedClass,
            // section: this.state.selectedSection,
            // type: this.state.selectedAssessmentType
            board: 'CBSE',
            class: this.props.selectedItem.class,
            type: this.props.type,
            questionSetId: this.props.selectedItem.questionSetId,
            section: this.props.selectedItem.sectionId,
            schoolAssessmentId : this.props.selectedItem._id
        }

        if (this.props.selectedItem.chapters && this.props.selectedItem.chapters[0].key) {
            payload.chapterKey = this.props.selectedItem.chapters[0].key
        }


        console.log(payload)

        this.setState({ isLoading: true })

        CommonApi.getPerformanceReport(payload).then(res => {
            console.log(res)


            let categories = this.state.categories

            categories.forEach(category => {

                if (category.type === 'NOVICE' && res.noviceStudents && res.noviceStudents.length) {
                    category.students = res.noviceStudents
                }

                if (category.type === 'PROFICIENT' && res.proficientStudents && res.proficientStudents.length) {
                    category.students = res.proficientStudents
                }

                if (category.type === 'ADVANCED' && res.advancedStudents && res.advancedStudents.length) {
                    category.students = res.advancedStudents
                }
            })

            this.setState({ showDiagnosticAssessmentReport: true, categories, reportData: res }, () => {
                this.setState({ isLoading: false })
            })
        }).catch(err => {
            this.setState({ isLoading: false })
            console.log(err)
        })
    }



    hideDiagnosticAssessmentReport() {

        this.props && this.props.close && this.props.close()

        this.setState({
            showDiagnosticAssessmentReport: false, isLoading: false, reportData: {},
            categories: [
                {
                    type: "NOVICE",
                    title: "Novice",
                    maxPercentage: 50,
                    students: [],
                    colorClass: "purble-header",
                    selectedCriterion: 1
                },
                {
                    type: "PROFICIENT",
                    title: "Proficient",
                    minPercentage: 50,
                    maxPercentage: 80,
                    students: [],
                    colorClass: "orange-header",
                    selectedCriterion: 1
                },
                {
                    type: "ADVANCED",
                    title: "Advanced",
                    minPercentage: 80,
                    students: [],
                    colorClass: "litebule-header",
                    selectedCriterion: 1
                }
            ]
        })
    }


    render() {
        if (this.state.showDiagnosticAssessmentReport) {
            return <DiagnosticAssessmentReport delegate={this}
                class={'Class 10'}
                sectionName={this.state.selectedAssessmentType === 'ALL' ? 'Overall' : this.props.selectedItem.section}
                homeworkId={this.props.selectedItem._id}
                reportData={{ categories: this.state.categories, ...this.state.reportData }}
                subjectId = {this.userInfo.subjectId}
                reportType={this.props.type === 'SELECTED_CHAPTER_MOCK_TEST' ? 'Maths Mock Test' :
                    this.props.type === 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST' ? "Science Mock Test" : this.props.type === 'CASE_STUDY' ? "Case Study Based Questions"
                        : this.userInfo.subjectId === Constants.SCIENCE_SUBJECTID ? 'Class Performance' : 'Class Performance'} />
        }


        return (
            <>
                {
                    this.state.isLoading ? <Loading /> : <></>
                }
            </>
        )
    }





}

export default StudentPerformanceReport;